/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Victor Manuel Calle Londoño                                ║
║ victor.calle@est.iudigital.edu.co                          ║
╚════════════════════════════════════════════════════════════╝
*/
import fetchWrapper from "fetchWrapper";
import React from "react";
import { date } from "yup";

const url = process.env.REACT_APP_API_URL;

//consultar el endpoint que me retornara el listado de carnets o error si ocurre y retornar esos datos
const getCarnetUserPerFile = async (id, pageIndex) => {
  try {
    const response = await fetchWrapper(
      url + `/cards/get_more_info_per_file/${id}?page=${pageIndex}`
    );
    if (response.status === 429) {
      // Manejar el error de demasiadas peticiones
      // console.error('Error 429: Too Many Requests');
      // Puedes lanzar un error o manejarlo de otra manera según tus necesidades
      // throw new Error('Too Many Requests');
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }
    const result = await response.json();
    const { success, code } = result;
    if (success === true) {
      const {
        payload: { data, last_page, total, from, to },
      } = result;
      return { data, last_page, total, from, to };
    } else if (success === false) {
      const message = result.message || "Error del servidor al realizar la solicitud";
      const status = false;
      return { status, message };
      //throw new Error(`Error del servidor al realizar la solicitud`);
    }
  } catch (error) {
    const message = error.message || "Error del servidor al realizar la solicitud";
    const status = false;
    return { status, message };
  }
};

const getDataSourceId = async (id) => {
  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_API_URL}/data_sources/data_source/${id}`
    );
    if (response.status === 429) {
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }
    const result = await response.json();
    const { success, code } = result;
    if (success === true) {
      const { payload } = result;
      return { payload };
    } else if (success === false) {
      const message = "Error del servidor al realizar la solicitud";
      const status = false;
      return { status, message };
    }
  } catch (error) {
    const message = "Error del servidor al realizar la solicitud";
    const status = false;
    return { status, message };
  }
};

//consultar el endpoint que me retornara la informacion de un usuario carnetizado por la id enviada del usuario o error si ocurre y retornar esos datos
const getUserId = async (idUser) => {
  try {
    const response = await fetchWrapper(url + `/card_users/card_user/${idUser}`);
    if (response.status === 429) {
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }
    const { id, name, lastname, number_id, email, created_at } = await response.json();
    return { id, name, lastname, number_id, email, created_at };
  } catch (error) {}
};

//consultar el endpoint que me retornara el listado de tipos de carnet o error si ocurre y retornar esos datos
const getTypeCarnets = async () => {
  try {
    const response = await fetchWrapper(process.env.REACT_APP_BASE_URL + `/card_types/`);
    if (response.status === 429) {
      // Manejar el error de demasiadas peticiones
      // console.error('Error 429: Too Many Requests');
      // Puedes lanzar un error o manejarlo de otra manera según tus necesidades
      // throw new Error('Too Many Requests');
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }
    const {
      payload: { data, last_page, total, from, to },
    } = await response.json();
    return { data, last_page, total, from, to };
  } catch (error) {}
};

// Enviar notificaciones
const sendCards = async (id, only_not_notified) => {
  const requestData = {
    data_source_file_id: id,
    only_not_notified: only_not_notified,
  };

  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_API_URL}/cards/send_email`,
      JSON.stringify(requestData), // Convertir el objeto a JSON
      "POST" // Usar método POST para enviar datos en el cuerpo
    );
    if (response.status === 429) {
      // Manejar el error de demasiadas peticiones
      // console.error('Error 429: Too Many Requests');
      // Puedes lanzar un error o manejarlo de otra manera según tus necesidades
      // throw new Error('Too Many Requests');
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }
    // Verificar si la respuesta es JSON
    const result = await response.json();

    // Verificar si la respuesta indica éxito
    if (response.ok) {
      return {
        status: 200,
        message: "Operación completada con éxito",
        data: result, // Incluyendo datos adicionales si es necesario
      };
    } else {
      // Si la respuesta no fue exitosa, lanzar un error con detalles
      throw new Error(result.message || "Error del servidor al realizar la solicitud");
    }
  } catch (error) {
    // Manejar cualquier tipo de error
    return {
      status: false,
      message: error.message || "Error del servidor al realizar la solicitud",
    };
  }
};

//consultar el endpoint que me retornara si el cambio de la vigencia de carnets fue exitoso o error si ocurre y retornar esos datos
const updatedCardValidity = async (editValidityCard) => {
  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_API_URL}/cards/validity`,
      JSON.stringify(editValidityCard),
      "POST"
    );
    if (response.status === 429) {
      // Manejar el error de demasiadas peticiones
      // console.error('Error 429: Too Many Requests');
      // Puedes lanzar un error o manejarlo de otra manera según tus necesidades
      // throw new Error('Too Many Requests');
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }
    const result = await response.json();
    const { success, code } = result;
    if (success === true) {
      const {
        payload: { data },
      } = result;
      return result;
    } else if (success === false) {
      const message = result.message || "Error del servidor al realizar la solicitud";
      const status = false;
      return { status, message };
    }
  } catch (error) {
    const message = error.message || "Error del servidor al realizar la solicitud";
    const status = false;
    return { status, message };
  }
};

const updatedStatusCarnet = async (id, statusCarnet) => {
  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_API_URL}/cards/edit/${id}`,
      JSON.stringify(statusCarnet),
      "POST"
    );

    if (response.status === 429) {
      // Manejar el error de demasiadas peticiones
      // console.error('Error 429: Too Many Requests');
      // Puedes lanzar un error o manejarlo de otra manera según tus necesidades
      // throw new Error('Too Many Requests');
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }

    const result = await response.json();
    const { success, code } = result;
    if (success === true) {
      return result;
    } else if (success === false) {
      const message = result.message || "Error del servidor al realizar la solicitud";
      const status = false;
      return { status, message };
    }
  } catch (error) {
    const message = error.message || "Error del servidor al realizar la solicitud";
    const status = false;
    return { status, message };
  }
};

//consultar el endpoint que me retornara si el envio de los carnets seleccionados fue exitoso o error si ocurre y retornar esos datos
const sendCarnetAccumulated = async (idCarnets) => {
  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_API_URL}/cards/send_carnet_accumulated`,
      JSON.stringify(idCarnets),
      "POST"
    );
    const result = await response.json();
    const { success, code } = result;
    if (success === true) {
      // const {
      //   payload: { data },
      // } = result;
      return result;
    } else if (success === false) {
      const message = result.message || "Error del servidor al realizar la solicitud";
      const status = false;
      return { status, message };
    }
  } catch (error) {
    const message = error.message || "Error del servidor al realizar la solicitud";
    const status = false;
    return { status, message };
  }
};

const CardAndUserCreateService = async (payload) => {
  try {
    const requestData = {
      name: payload.name,
      lastname: payload.lastname,
      number_id: payload.number_id,
      blood_type: payload.blood_type,
      status: payload.status,
      created: payload.created,
      expires_in: payload.expires_in,
      card_type_id: payload.card_type_id,
      email: payload.email,
      data_source_id: payload.data_source_id,
      userId: payload.userId,
      special_condition: payload.special_condition,
      origin_place: payload.origin_place,
    };

    const response = await fetchWrapper(
      `${process.env.REACT_APP_API_URL}/cards/create_user_and_card_in_source`,
      JSON.stringify(requestData),
      "POST"
    );

    const result = await response.json();

    if (result.success && result.code) {
      return {
        status: true,
        message: result.message,
        data: result.payload,
      };
    }

    return {
      status: true,
      data: result.payload,
    };
  } catch (error) {
    console.error("Error en la solicitud:", error);

    return {
      status: false,
      errors: [error.message || "Error del servidor al procesar la solicitud"],
    };
  }
};

export {
  getCarnetUserPerFile,
  getUserId,
  getTypeCarnets,
  updatedCardValidity,
  updatedStatusCarnet,
  sendCards,
  sendCarnetAccumulated,
  CardAndUserCreateService,
  getDataSourceId,
};
